import styled from 'styled-components';

export const CenteredContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
`;

export const MainContainer = styled.div`
    background-color: #ffffff;
    display: flex;
    border-radius: 20px;
    width: 429px;
    padding: 32px;
`;

export const ContentContainer = styled.div`
    flex: 1;
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    gap: 32px;
`;

export const Title = styled.p`
    font-family: Amigo;
    font-weight: 400;
    font-size: 22px;
    color: #14142b;
`;

export const AmigoButton = styled.button`
    font-family: Amigo;
    display: inline-block;
    background-color: #7d00ff;
    color: #ffffff;
    text-decoration: none;
    font-weight: 700;
    padding: 12px 24px;
    border-radius: 999px;
`;
